export const dashedLegend = () => {
  // because this SVG is used a bunch of times, and the fill is controlled by a pattern, the
  // pattern has to be unique, otherwise different elements with the same pattern will get the same styling.
  // at least this is what happened in our legend use case.
  const pattern = `pattern_${Math.random() * 10000000}`;
  return `
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
    <defs>
      <pattern id="${pattern}" patternUnits="userSpaceOnUse" width="2.5" height="2.5" patternTransform="rotate(45)">
        <line x1="0" y="0" x2="0" y2="2.5" stroke-width="2" />
        <line x1="2" y="0" x2="2" y2="2.5" stroke-width="2" opacity="0.1"/>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#${pattern})" :opacity="1" />
  </svg>`;
};
